<app-breadcrumb [links]="[{link: 'admin', name: 'Administração'}]" current="Gestão de Marcas"></app-breadcrumb>
<div class="backgroundColor mine-shaft base">
  <!--Cards-->
  <section class="container-fluid backgroundColor mine-shaft base nav-border-bottom position-relative top-119 six-cards">
    <div id="row" class="container position-relative top-85">
      <div class="col-12 d-flex">
        <div class="col-12 col-xl-6">
          <div class="pt-10 d-flex text-sm-center textColor harvest-gold base text-shadow">
            <h1>Ordenação de Marcas por Categoria</h1>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-10 d-flex textColor harvest-gold base text-shadow">
            <app-backtoadmin></app-backtoadmin>
          </div>
        </div>
      </div>
      <div class="row py-5">
        <div class="col-12 col-md-6 col-lg-4 mt-3">
          <div class="card mb-3 card-expand shadow-card">
            <div class="row no-gutters">
              <div class="col-md-7 col-7">
                <div class="card-body">
                  <h2 class="card-title textColor new-orleans base font-italic">Alta Relojoaria</h2>
                  <p class="card-text text-white"><br></p>
                  <a class="font-decoration text-white" href="admin/gestaoMarcas/alta"><button class="btn btn-grad">Ir para</button></a>
                </div>
              </div>
              <div class="col-md-5 col-5  mx-auto my-auto">
                <img class="img-fluid pr-3" src="../../assets/images/cardFilter/altaRelojoaria.png" alt="...">
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mt-3">
          <div class="card mb-3 card-expand shadow-card">
            <div class="row no-gutters">
              <div class="col-md-7 col-7">
                <div class="card-body">
                  <h2 class="card-title textColor new-orleans base font-italic">Relojoaria</h2>
                  <p class="card-text text-white"><br></p>
                  <a class="font-decoration text-white" href="admin/gestaoMarcas/relojoaria"><button class="btn btn-grad">Ir para</button></a>
                </div>
              </div>
              <div class="col-md-4 col-4  mx-auto my-auto">
                <img class="img-fluid pr-3" src="../../assets/images/cardFilter/relojoaria.png" alt="...">
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mt-3">
          <div class="card mb-3 card-expand shadow-card">
            <div class="row no-gutters">
              <div class="col-md-7 col-7">
                <div class="card-body">
                  <h2 class="card-title textColor new-orleans base font-italic">Joalharia</h2>
                  <p class="card-text text-white"><br></p>
                  <a class="font-decoration text-white" href="admin/gestaoMarcas/joias"><button class="btn btn-grad">Ir para</button></a>
                </div>
              </div>
              <div class="col-md-5 col-5  mx-auto my-auto">
                <img class="img-fluid pr-3" src="../../assets/images/cardFilter/joias.png" alt="...">
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mt-3">
          <div class="card mb-3 card-expand shadow-card">
            <div class="row no-gutters">
              <div class="col-md-7 col-7">
                <div class="card-body">
                  <h2 class="card-title textColor new-orleans base font-italic">Noivas</h2>
                  <p class="card-text text-white"><br></p>
                  <a class="font-decoration text-white" href="admin/gestaoMarcas/noivas"><button class="btn btn-grad">Ir para</button></a>
                </div>
              </div>
              <div class="col-md-5 col-5  mx-auto my-auto">
                <img class="img-fluid pr-3" src="../../assets/images/cardFilter/noivas.png" alt="...">
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mt-3">
          <div class="card mb-3 card-expand shadow-card">
            <div class="row no-gutters">
              <div class="col-md-7 col-7">
                <div class="card-body">
                  <h2 class="card-title textColor new-orleans base font-italic">Pratas</h2>
                  <p class="card-text text-white"><br></p>
                  <a class="font-decoration text-white" href="admin/gestaoMarcas/pratas"><button class="btn btn-grad">Ir para</button></a>
                </div>
              </div>
              <div class="col-md-4 col-5  mx-auto my-auto">
                <img class="img-fluid pr-3" src="../../assets/images/cardFilter/pratas.png" alt="...">
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mt-3">
          <div class="card mb-3 card-expand shadow-card">
            <div class="row no-gutters">
              <div class="col-md-6 col-7">
                <div class="card-body">
                  <h2 class="card-title textColor new-orleans base font-italic">Acessórios</h2>
                  <p class="card-text text-white"><br></p>
                  <a class="font-decoration text-white" href="admin/gestaoMarcas/acessorios"><button class="btn btn-grad">Ir para</button></a>
                </div>
              </div>
              <div class="col-md-6 col-5  mx-auto my-auto">
                <img class="img-fluid pr-3" src="../../assets/images/cardFilter/acessorios.png" alt="...">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>